import React from 'react';

const PrimeSubscriptionHero = () => (
  <div className="w-full bg-gradient-to-r from-[#85BFFF66] to-[#FFFFFF] rounded-[10px] py-8 md:py-14 px-4 md:px-6 text-center mb-6 md:mb-10 border border-[#E0E0E0] shadow-sm animate-in fade-in duration-700">
    
    <h1 className="text-[20px] font-[500] text-[#000000] mb-3 md:mb-4 font-inter tracking-tight leading-tight">
      Unlock Your Potential with  Prime Subscription
    </h1>
    <p className="text-[14px] md:text-[16px] text-[#000000] max-w-full sm:max-w-[600px] md:max-w-[700px] mx-auto font-medium leading-relaxed font-inter px-2">
      Get access to 70,000+ mock tests, unlimited practice questions, and comprehensive study materials to ace your government job exams.
    </p>
  </div>
);

export default PrimeSubscriptionHero;